/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import moment from 'moment-timezone';

const iso8601DateTimeFormat = 'YYYY-MM-DDTHHmm';
const militaryTimeFormat = 'HHmm';

/**
 * @param localDate A date in yyyy-mm-dd format, e.g. 2018-10-01
 * @returns {string} The year in yyyy format, e.g. 2018
 */
export function getYear(localDate) {
    return localDate.split('-')[0];
}

/**
 * @param localDate A date in yyyy-mm-dd format, e.g. 2018-10-01
 * @returns {string} The month in mm format, e.g. 10
 */
export function getMonth(localDate) {
    return localDate.split('-')[1];
}

// Turns a string like '1600' into '4:00 PM'
export function convertMilitaryTime(timeString) {
    let hour = parseInt(timeString.slice(0, 2), 10);
    const minutes = timeString.slice(2);
    let amPm = 'AM';

    if (hour > 12) {
        amPm = 'PM';
        hour -= 12;
    } else if (hour === 12) {
        amPm = 'PM';
    } else if (hour === 0) {
        hour = '12'; //AM
    }

    const civilianTime = `${hour}:${minutes} ${amPm}`;
    return civilianTime;
}

export function toLocalTime(input) {
    if (input instanceof Date) {
        return moment().set(input).format(militaryTimeFormat);
    }
    if (moment.isMoment(input)) {
        return input.format(militaryTimeFormat);
    }
    if (!input) {
        return input;
    }

    throw new Error('Invalid parameter.  Required: moment or Date.');
}

export function toMoment(localDate, localTime = '0000', timeZone) {
    if (timeZone) {
        return moment.tz(`${localDate}T${localTime}`, iso8601DateTimeFormat, timeZone);
    }
    return moment(`${localDate}T${localTime}`, iso8601DateTimeFormat);
}
